export enum CustomFieldType {
  TEXT = 'text',
  NUMBER = 'number',
  DROPDOWN = 'dropdown',
  BOOLEAN = 'boolean',
}

export enum CustomFieldScope {
  BUILDING = 'building',
  UNIT = 'unit',
}

export interface AIExtractionConfig {
  enabled: boolean;
  fileLabels: string[];
  extractionPrompt: string;
}

export interface CustomFieldDefinition {
  id: number;
  name: string;
  fieldKey: string;
  fieldType: CustomFieldType;
  scope: CustomFieldScope;
  dropdownOptions: string[] | null;
  displayOrder: number;
  active: boolean;
  aiExtractionConfig: AIExtractionConfig | null;
  createdAt: string;
  updatedAt: string;
  createdBy: string | null;
}

export interface CustomFieldValue {
  id: number;
  fieldDefinitionId: number;
  buildingId: string | null;
  unitId: string | null;
  textValue: string | null;
  numberValue: number | null;
  booleanValue: boolean | null;
  source: string | null;
  aiConfidence: number | null;
  sourceFileLogId: number | null;
  createdAt: string;
  updatedAt: string;
  updatedBy: string | null;
  fieldDefinition?: CustomFieldDefinition;
}

export interface CustomFieldExtraction {
  fieldDefinitionId: number;
  fieldName: string;
  fieldKey: string;
  fieldType: string;
  extractedValue: string | number | boolean | null;
  confidence: number;
  reasoning: string;
}

export interface CreateCustomFieldDTO {
  name: string;
  fieldType: CustomFieldType;
  scope: CustomFieldScope;
  dropdownOptions?: string[];
}

export interface UpdateCustomFieldDTO {
  name?: string;
  dropdownOptions?: string[];
  displayOrder?: number;
  active?: boolean;
}

export interface SaveCustomFieldValueDTO {
  fieldDefinitionId: number;
  buildingId?: string;
  unitId?: string;
  textValue?: string;
  numberValue?: number;
  booleanValue?: boolean;
}
